<template>
  <div>
    <v-dialog persistent v-model="inclusionDialog" max-width="1000px">
      <inclusion
        :inclusion="this.inclusionSelected"
        :key="inclusionKey" :sourceGroups="sourceGroups" :targetGroups="targetGroups"
        @close-inclusion="closeInclusion"
        @save-inclusion="saveInclusion"
      ></inclusion>
    </v-dialog>
    <v-dialog persistent v-model="exclusionDialog" max-width="1000px">
      <exclusion
        :exclusion="this.exclusionSelected"
        :key="exclusionKey" :sourceGroups="sourceGroups" :targetGroups="targetGroups"
        @close-exclusion="closeExclusion"
        @save-exclusion="saveExclusion"
      ></exclusion>
    </v-dialog>
    <v-container>
          <v-layout>
            <v-flex xs12 sm6 md4>
              <!-- <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn> -->
              <v-btn @click="newInclusion" color="primary" dark class="mb-2">New Group Inclusion</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
    <v-card>
      <v-data-table
        :v-model="inclusionSelected"
        :headers="inclusionHeaders"
        :items="inclusionsList"
        :loading="loadingData"
        item-key="id"
        class="elevation-1"
        :rows-per-page="incRowsPerPage"
        :items-per-page-options="incRppItems"
      >
        <template v-slot:top>
          <v-card-title>Group  Inclusions</v-card-title>
        </template>
        <template slot="item" slot-scope="props">
            <tr>
              <td class="text-xs-left" @click="editInclusion(props.item)">{{ props.item.id }}</td>
              <td class="text-xs-left" @click="editInclusion(props.item)">{{ props.item.sourceGroup.id }}</td>
              <td class="text-xs-left" @click="editInclusion(props.item)">{{ props.item.sourceGroup.name }}</td>
              <td class="text-xs-left" @click="editInclusion(props.item)">{{ (props.item.includedGroup !== undefined) ? props.item.includedGroup.id : null }}</td>
              <td class="text-xs-left" @click="editInclusion(props.item)">{{ (props.item.includedGroup !== undefined) ? props.item.includedGroup.name : null }}</td>
              <td class="text-xs-left" @click="editInclusion(props.item)">{{ props.item.type }}</td>
              <td class="text-xs-left" @click="editInclusion(props.item)">{{ props.item.createdDate }}</td>
              <td class="text-xs-left" @click="editInclusion(props.item)">{{ props.item.startDate }}</td>
              <td class="text-xs-left" @click="editInclusion(props.item)">{{ props.item.endDate }}</td>
              <td class="justify-center layout px-4">
                <v-icon small @click="deleteInclusion(props.item)">visibility</v-icon>
              </td>
            </tr>
          </template>
          <template slot="no-data"></template>
      </v-data-table>
    </v-card>
    <v-container>
          <v-layout>
            <v-flex xs12 sm6 md4>
              <!-- <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn> -->
              <v-btn @click="openExclusion" color="primary" dark class="mb-2">New Group Exclusion</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
    <v-card>
      <v-data-table
        :v-model="exclusionSelected"
        :headers="exclusionHeaders"
        :items="exclusionsList"
        :loading="loadingData"
        item-key="id"
        class="elevation-1"
        :rows-per-page="excRowsPerPage"
        :items-per-page-options="excRppItems"
      >
        <template v-slot:top>
          <v-card-title>Group  Exclusions</v-card-title>
        </template>
        <template slot="item" slot-scope="props">
            <tr>
              <td class="text-xs-left" @click="selectExclusion(props.item)">{{ props.item.id }}</td>
              <td class="text-xs-left" @click="selectExclusion(props.item)">{{ props.item.sourceGroup.id }}</td>
              <td class="text-xs-left" @click="selectExclusion(props.item)">{{ props.item.sourceGroup.name }}</td>
              <td class="text-xs-left" @click="selectExclusion(props.item)">{{ (props.item.excludedGroup !== undefined) ? props.item.excludedGroup.id : null }}</td>
              <td class="text-xs-left" @click="selectExclusion(props.item)">{{ (props.item.excludedGroup !== undefined) ? props.item.excludedGroup.name : null  }}</td>
              <td class="text-xs-left" @click="selectExclusion(props.item)">{{ props.item.type }}</td>
              <td class="text-xs-left" @click="selectExclusion(props.item)">{{ props.item.createdDate }}</td>
              <td class="text-xs-left" @click="selectExclusion(props.item)">{{ props.item.startDate }}</td>
              <td class="text-xs-left" @click="selectExclusion(props.item)">{{ props.item.endDate }}</td>
              <td class="justify-center layout px-4">
                <v-icon small @click="deleteExclusion(props.item)">visibility</v-icon>
              </td>
            </tr>
          </template>
          <template slot="no-data"></template>
      </v-data-table>
    </v-card>
  </div>
</template>

<style>
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}
</style>

<script>
import inclusion from '@/components/GroupInclusion.vue'
import exclusion from '@/components/GroupExclusion.vue'
let rh = require('@/components/APIs/RequestHandler')
let mh = require('@/components/APIs/MessageHandler')

export default {

  data: () => ({
    model: null,
    inclusionsList: [],
    sourceGroups: [],
    targetGroups: [],
    exclusionsList: [],
    exclusionDialog: false,
    inclusionDialog: false,
    inclusionSelected: null,
    exclusionSelected: null,
    quberGroup: {
      id: 1,
      name: 'QUBER'
    },
    nullGroup: {
      id: -1,
      name: ''
    },
    defaultInclusion: {
      id: 0,
      sourceGroup: {
        id: 0,
        name: ''
      },
      includedGroup: {
        id: 0,
        name: ''
      },
      createdDate: '',
      startDate: '',
      endDate: ''
    },
    defaultExclusion: {
      id: 0,
      sourceGroup: {
        id: 0,
        name: ''
      },
      excludedGroup: {
        id: 0,
        name: ''
      },
      createdDate: '',
      startDate: '',
      endDate: ''
    },
    inclusionKey: 0,
    exclusionKey: 0,
    panel: [[true], [false], [false], [false], [false]],
    incRppItems: [
      5,
      10,
      15,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    incRowsPerPage: 5,
    excRppItems: [
      5,
      10,
      15,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    excRowsPerPage: 5,
    inclusionHeaders: [
      {
        text: 'Id',
        value: 'id'
      },
      { text: 'Source Group Id', value: 'sourceGroupId' },
      { text: 'Source Group', value: 'sourceGroup.name' },
      { text: 'Included Group Id', value: 'includedGroupId' },
      { text: 'Include Group', value: 'includedGroup.name' },
      { text: 'Type', value: 'type' },
      { text: 'Created Date', value: 'createdDate' },
      { text: 'Start Date', value: 'startDate' },
      { text: 'End Date', value: 'endDate' }
    ],
    exclusionHeaders: [
      {
        text: 'Id',
        value: 'id'
      },
      { text: 'Source Group Id', value: 'sourceGroupId' },
      { text: 'Source Group', value: 'sourceGroup.name' },
      { text: 'Excluded Group Id', value: 'excludedGroupId' },
      { text: 'Exclude Group', value: 'excludedGroup.name' },
      { text: 'Type', value: 'type' },
      { text: 'Created Date', value: 'createdDate' },
      { text: 'Start Date', value: 'startDate' },
      { text: 'End Date', value: 'endDate' }
    ],
    editedInclusionIndex: -1,
    editedExclusionIndex: -1
  }),

  components: {
    inclusion,
    exclusion
  },

  computed: {},

  created () {
    this.initialize()
  },

  methods: {
    async initialize () {
      this.loadingData = true
      var incEndpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/groups/inclusions`
      var getResponse = await rh.default.get(incEndpoint, true).catch(e => {
        this.errors.push(e)
      })
      this.inclusionsList = getResponse.data

      var excEndpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/groups/exclusions`
      var excGetResponse = await rh.default.get(excEndpoint, true).catch(e => {
        this.errors.push(e)
      })
      this.exclusionsList = excGetResponse.data

      var groupEndpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/groups`
      var groupResponse = await rh.default.get(groupEndpoint, true).catch(e => {
        this.errors.push(e)
      })
      this.sourceGroups = groupResponse.data
      this.sourceGroups.unshift(this.quberGroup)
      let tGroups = JSON.parse(JSON.stringify(this.sourceGroups))
      this.targetGroups = tGroups
      this.loadingData = false
    },
    closeInclusion () {
      this.inclusionDialog = false
      this.inclusionSelected = null
    },
    newInclusion () {
      this.inclusionSelected = null
      this.inclusionDialog = true
      this.inclusionKey++
    },
    editInclusion (item) {
      this.inclusionDialog = true
      this.inclusionSelected = item
      this.inclusionKey++
    },
    async deleteInclusion (item) {
      const index = this.inclusionsList.indexOf(item)
      if (confirm('Are you sure you want to delete this group inclusion?')) {
        var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/groups/inclusions/${item.id}`

        var response = await rh.default
          .delete(endpoint, true)
          .catch(e => {
            this.errors.push(e)
          })

        if (response !== undefined && response.status === 200) {
          this.inclusionsList.splice(index, 1)
        } else alert('Failed to delete group inclusion')
      }
    },
    async deleteExclusion (item) {
      const index = this.exclusionsList.indexOf(item)
      if (confirm('Are you sure you want to delete this group exclusion?')) {
        var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/groups/exclusions/${item.id}`

        var response = await rh.default
          .delete(endpoint, true)
          .catch(e => {
            this.errors.push(e)
          })

        if (response !== undefined && response.status === 200) {
          this.exclusionsList.splice(index, 1)
        } else alert('Failed to delete group exclusion')
      }
    },
    saveInclusion (inclusion) {
      this.inclusionDialog = false
      var savedIndex = this.inclusionsList.indexOf(this.inclusionSelected)
      var savedInclusion = JSON.parse(inclusion)
      // console.log('savedInclusion')
      // console.log(savedInclusion)
      if (savedIndex !== -1) {
        this.inclusionsList[savedIndex].id = savedInclusion.id
        if (savedInclusion.includedGroup != null) {
          this.inclusionsList[savedIndex].includedGroup.id = savedInclusion.includedGroup.id
          this.inclusionsList[savedIndex].includedGroup.name = savedInclusion.includedGroup.name
          this.inclusionsList[savedIndex].includedGroupId = savedInclusion.includedGroupId
        }
        this.inclusionsList[savedIndex].sourceGroup.id = savedInclusion.sourceGroup.id
        this.inclusionsList[savedIndex].sourceGroup.name = savedInclusion.sourceGroup.name
        this.inclusionsList[savedIndex].sourceGroupId = savedInclusion.sourceGroupId
        this.inclusionsList[savedIndex].startDate = savedInclusion.startDate
        this.inclusionsList[savedIndex].endDate = savedInclusion.endDate
        this.inclusionSelected = null
        this.inclusionSelected = this.defaultInclusion
      } else {
        let newInclusion = Object.assign({}, this.defaultInclusion)
        newInclusion.id = savedInclusion.id
        newInclusion.createDate = savedInclusion.createdDate
        if (savedInclusion.includedGroup != null) {
          newInclusion.includedGroup.id = savedInclusion.includedGroup.id
          newInclusion.includedGroup.name = savedInclusion.includedGroup.name
          newInclusion.includedGroupId = savedInclusion.includedGroupId
        }
        newInclusion.sourceGroup.id = savedInclusion.sourceGroup.id
        newInclusion.sourceGroup.name = savedInclusion.sourceGroup.name
        newInclusion.sourceGroupId = savedInclusion.sourceGroupId
        newInclusion.startDate = savedInclusion.startDate
        newInclusion.endDate = savedInclusion.endDate
        this.inclusionsList.push(newInclusion)
      }
    },
    openExclusion () {
      this.exclusionDialog = true
      this.exclusioKey++
    },

    closeExclusion () {
      this.exclusionDialog = false
      this.exclusionSelected = null
    },
    async selectInclusion (a) {
      this.inclusionSelected = a
      this.inclusionDialog = true
      this.inclusionKey++
    },
    async selectExclusion (a) {
      this.exclusionSelected = a
      this.exclusionDialog = true
      this.exclusionKey++
    },
    saveExclusion (exclusion) {
      this.exclusionDialog = false
      var savedIndex = this.exclusionsList.indexOf(this.exclusionSelected)
      var savedExclusion = JSON.parse(exclusion)

      if (savedIndex !== -1) {
        this.exclusionsList[savedIndex].id = savedExclusion.id
        if (this.savedExclusion.excludedGroup != null) {
          this.exclusionsList[savedIndex].excludedGroup.id = savedExclusion.excludedGroup.id
          this.exclusionsList[savedIndex].excludedGroup.name = savedExclusion.excludedGroup.name
          this.exclusionsList[savedIndex].excludedGroupId = savedExclusion.excludedGroupId
        }
        this.exclusionsList[savedIndex].sourceGroup.id = savedExclusion.sourceGroup.id
        this.exclusionsList[savedIndex].sourceGroup.name = savedExclusion.sourceGroup.name
        this.exclusionsList[savedIndex].sourceGroupId = savedExclusion.sourceGroupId
        this.exclusionsList[savedIndex].startDate = savedExclusion.startDate
        this.exclusionsList[savedIndex].endDate = savedExclusion.endDate
        this.exclusionSelected = null
        this.exclusionSelected = this.defaultExclusion
      } else {
        let newExclusion = Object.assign({}, this.defaultExclusion)
        newExclusion.id = savedExclusion.id
        newExclusion.createDate = savedExclusion.createdDate
        if (this.savedExclusion.excludedGroup != null) {
          newExclusion.excludedGroup.id = savedExclusion.excludedGroup.id
          newExclusion.excludedGroup.name = savedExclusion.excludedGroup.name
          newExclusion.excludedGroupId = savedExclusion.excludedGroupId
        }
        newExclusion.sourceGroup.id = savedExclusion.sourceGroup.id
        newExclusion.sourceGroup.name = savedExclusion.sourceGroup.name
        newExclusion.sourceGroupId = savedExclusion.sourceGroupId
        newExclusion.startDate = savedExclusion.startDate
        newExclusion.endDate = savedExclusion.endDate
        this.exclusionsList.push(newExclusion)
      }
    }
  }
}
</script>
